// extracted by mini-css-extract-plugin
export default {"layout":"AppLayout_layout__fDxOF","mobileLayout":"AppLayout_mobileLayout__BG7Yc","desktopLayout":"AppLayout_desktopLayout__YjuAk"};